import gql from 'graphql-tag';

export const GET_PLACE_QUERY = gql`
  query GetPlace($id: ID!) {
    place(id: $id) {
      id
      name
      description
      page {
        id
        title
      }

      images {
        image {
          id
          url
        }
        type
      }

      locations(first: 1) {
        edges {
          node {
            address {
              streetAddress
              locality
              region
              postalCode
            }
          }
        }
      }

      tags {
        id
        name
      }
    }
  }
`;
